import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';

interface DashboardHeaderProps {
  onRefresh: () => void;
  loading: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onRefresh, loading }) => (
    <div className='auto-render-dashboard__header'>
      <div>
        <Typography.Title level={2} className='auto-render-dashboard__title'>
          Auto Render Pipeline
        </Typography.Title>
        <Typography.Text type='secondary'>
          Track queued, rendering, and failed jobs grouped by project, unit type, and unit number.
        </Typography.Text>
      </div>
      <Space>
        <Button
          icon={<ReloadOutlined />}
          onClick={onRefresh}
          loading={loading}
          type='primary'
        >
          Refresh
        </Button>
      </Space>
    </div>
  );
